<template>
  <button class="cta" @click="scrollSection(id)">
    <p class="cta__label">{{ label }}</p>
    <icon class="cta__icon" :data="pageIcons[icon]" width="auto"></icon>
  </button>
</template>

<script setup>
import { pageIcons } from "../../../plugins/page-icons";

defineProps({
  icon: String,
  label: String,
  id: String,
});

const scrollSection = (value) => {
  document.getElementById(value).scrollIntoView({ behavior: "smooth" });
};
</script>

<style lang="scss" scoped>
@keyframes bouncy-arrow {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(10px);
  }
}
.cta {
  position: absolute;
  bottom: toRem(75);
  left: 50%;
  transform: translateX(-50%);

  .mobile & {
    bottom: 6vh;
  }

  &__label {
    color: $scala-grigi-gray_1;
    @include link-m;
  }

  &__icon {
    height: 4.188rem;
    width: auto;
    animation: bouncy-arrow 1s infinite alternate;
  }
}
</style>
